import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { ChartDataPoint, Moneda } from '@/contabilidad/types';
import { formatCurrencyCompact } from '@/contabilidad/utils/formatters';

interface CashflowChartProps {
  data: ChartDataPoint[];
  moneda?: Moneda;
}

export function CashflowChart({ data, moneda = 'ARS' }: CashflowChartProps) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} margin={{ top: 4, right: 4, left: 8, bottom: 4 }}>
        <CartesianGrid strokeDasharray="4 4" stroke="#e5e7eb" vertical={false} />
        <XAxis dataKey="mes" tick={{ fontSize: 12 }} axisLine={false} tickLine={false} />
        <YAxis
          tickFormatter={(v) => formatCurrencyCompact(v, moneda)}
          tick={{ fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          width={68}
        />
        <Tooltip
          formatter={(value: number) => formatCurrencyCompact(value, moneda)}
          contentStyle={{ borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '12px' }}
        />
        <Legend wrapperStyle={{ fontSize: '12px' }} />
        <Bar dataKey="ingresos" name={`Ingresos ${moneda}`} fill="#4B7FD4" radius={[4, 4, 0, 0]} />
        <Bar dataKey="egresos"  name={`Egresos ${moneda}`}  fill="#BCC8D8" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
